import Fuse from 'fuse.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultOptions = {
  threshold: 0.5,
  minMatchCharLength: 1,
  useExtendedSearch: true
};
function createFaqSearch(faqItems, options) {
  const fuse = new Fuse(faqItems, __spreadValues(__spreadProps(__spreadValues({}, defaultOptions), {
    distance: Infinity,
    keys: [
      { name: "question", weight: 0.7 },
      { name: "answer", weight: 0.5 }
    ]
  }), options));
  function search(query, limit = 24) {
    const searchQuery = (query || "").trim();
    return fuse.search(`=${searchQuery} | '${searchQuery} | ${searchQuery}`, {
      limit
    }).map((result) => {
      return result.item;
    });
  }
  return search;
}

export { createFaqSearch };
